import React from 'react';

const toneClasses = {
  success: 'border-green-200 bg-green-50 text-green-800',
  error: 'border-red-200 bg-red-50 text-red-800',
  warning: 'border-amber-200 bg-amber-50 text-amber-800',
  info: 'border-[#E4D4EA] bg-[#FBF7FD] text-[#4B2A56]',
};

const toneIcons = {
  success: '✅',
  error: '⚠️',
  warning: '⚠️',
  info: 'ℹ️',
};

const InlineFeedback = ({ message, type = 'info', className = '' }) => {
  if (!message) return null;

  const resolvedType = toneClasses[type] ? type : 'info';
  const liveRole = resolvedType === 'error' ? 'alert' : 'status';

  return (
    <div
      role={liveRole}
      aria-live={resolvedType === 'error' ? 'assertive' : 'polite'}
      className={`rounded-lg border px-3 py-2 text-sm ${toneClasses[resolvedType]} ${className}`.trim()}
    >
      <span className="mr-2" aria-hidden="true">{toneIcons[resolvedType]}</span>
      <span>{message}</span>
    </div>
  );
};

export default InlineFeedback;